export class BooleanUtils {
  public static booleanToStringReturnValue(bool: boolean | null): string {
    if (bool === null) {
      return '';
    } else {
      return bool ? 'Yes' : 'No';
    }
  }
}
